import { defineComponent as u, ref as p, useId as m, toRef as n, createElementBlock as f, openBlock as c, createBlock as _, createCommentVNode as g, createElementVNode as l, unref as s } from "vue";
import { ScalarCodeBlockCopy as k } from "@scalar/components";
import { prettyPrintJson as y } from "@scalar/oas-utils/helpers";
import { useCodeMirror as b } from "@scalar/use-codemirror";
const v = { class: "scalar-code-block group/code-block body-raw grid min-h-0 overflow-hidden p-px outline-none has-[:focus-visible]:outline" }, C = {
  class: "body-raw-scroller custom-scroll relative pr-1",
  tabindex: "0"
}, M = /* @__PURE__ */ u({
  __name: "ResponseBodyRaw",
  props: {
    content: {},
    language: {}
  },
  setup(a) {
    const o = a, t = p(null), d = m(), { codeMirror: i } = b({
      codeMirrorRef: t,
      readOnly: !0,
      lineNumbers: !0,
      content: n(() => y(o.content)),
      language: n(() => o.language),
      forceFoldGutter: !0
    }), r = () => {
      var e;
      return ((e = i.value) == null ? void 0 : e.state.doc.toString()) || "";
    };
    return (e, h) => (c(), f("div", v, [
      r() ? (c(), _(s(k), {
        key: 0,
        content: r(),
        controls: s(d),
        class: "z-context top-2 mr-2"
      }, null, 8, ["content", "controls"])) : g("", !0),
      l("div", C, [
        l("div", {
          ref_key: "codeMirrorRef",
          ref: t
        }, null, 512)
      ])
    ]));
  }
});
export {
  M as default
};
